import React, { Component } from 'react';
import { Switch } from 'react-router';
import { Route } from 'react-router-dom';
import { formatRoute } from 'react-router-named-routes';
import ExpiredCourtesyPage from '../components/ExpiredCourtesyPage';
import GameHeader from '../components/GameHeader';
import HeartsAndMoney from '../components/HeartsAndMoney';
import Icon from '../components/Icon';
import Loader from '../components/Loader';
import MainLayout from '../components/MainLayout';
import MainLink from '../components/MainLink';
import PdfViewer from '../components/PdfViewer';
import PopUpMail from '../components/PopUpMail';
import ReadyCourtesyPage from '../components/ReadyCourtesyPage';
import ResultsDocument from '../components/ResultsDocument';
import GameQuery from '../query/GameQuery';
import { BUSINESSPLAN, DOCUMENTS, INBOX, PDF, RESULTS, RESULTSDOCUMENT } from '../routes';
import BusinessPlanRoute from '../screens/BusinessPlanRoute';
import DocumentsRoute from '../screens/DocumentsRoute';
import InboxRoute from '../screens/InboxRoute';
import ResultsRoute from '../screens/ResultsRoute';
import './styles.css';


class Game extends Component {
	render() {


		return (
			<GameQuery>

				{({ game }) => (
					<>
						{
							game.status === 'not-started' && <ReadyCourtesyPage />
						}
						{
							game.status === 'expired' && <ExpiredCourtesyPage />
						}
						{
							game.status === 'running' && <MainLayout>
								<GameHeader>
									<div className='header-central-elements-container'>
										<Icon className="erisPoint" icon={'erisPoint'} />
										<div className='header-other-informations'>
											<GameQuery>
												<HeartsAndMoney />
											</GameQuery>
										</div>
									</div>
									<Icon className="icon-logoAreaHeader" icon={'logoAreaHeader'} />
								</GameHeader>
								<Route
									path={PDF}
									render={props => (
										<MainLayout.PopUp>
											<PdfViewer {...props} scenario={game.scenario.name}/>
										</MainLayout.PopUp>
									)}
								/>
								<Route
									path={RESULTSDOCUMENT}
									render={props => (
										<MainLayout.PopUp>
											<GameQuery>
												<ResultsDocument {...props} />
											</GameQuery>
										</MainLayout.PopUp>
									)}
								/>
								<MainLayout.Body game={game}>
									<MainLayout.Menu>
										<GameQuery>
											{({ game }) => {
												const notReaded = game.emails.filter(email => !email.isRead)
													.length;
												return (
													<MainLink
														to={formatRoute(INBOX, { gameID: game.id })}
														icon="inbox"
														label="Mail"
														active={true}
														hasBadge={notReaded > 0}
														badgeCount={notReaded}
													/>
												);
											}}
										</GameQuery>
										<MainLink
											to={formatRoute(BUSINESSPLAN, {
												gameID: game.id,
												businessPlanID: game.currentBusinessPlan.submission
											})}
											label="Business Plan"
											icon="doc"
											active={true}
										/>
									</MainLayout.Menu>
									<MainLayout.Content>
										<Switch>
											<Route path={INBOX} component={InboxRoute} />
											<Route path={DOCUMENTS} component={DocumentsRoute} />
											<Route path={BUSINESSPLAN} component={BusinessPlanRoute} />
											<Route path={RESULTS} component={ResultsRoute} />
										</Switch>
									</MainLayout.Content>
									<MainLayout.Menu>
										<MainLink
											to={formatRoute(DOCUMENTS, { gameID: game.id })}
											icon="folder"
											label="Documents"
											active={true}
										/>
										<MainLink
											to={formatRoute(RESULTS, { gameID: game.id })}
											icon="results"
											label="Results"
											active={true}
										/>
									</MainLayout.Menu>
									{false && <PopUpMail />}
									{game.loading && <Loader />}
								</MainLayout.Body>
							</MainLayout>
						}
					</>
				)}
			</GameQuery>
		);
	}
}

export default Game;
